import i18next from "i18next";
import { payeeLogs } from "../store/api";
import { TRACKING_TAGS } from "./constants";

// eventLogger.js
class EventLogger {
    constructor() {
        this.trackEvent = this.trackEvent.bind(this);
    }

    init() {
        document.addEventListener("click", this.trackEvent);
    }

    async trackEvent(event) {
        try {
            let target = event.target;
            let tagName = target.tagName.toLowerCase();
            if (TRACKING_TAGS.indexOf(tagName) === -1) {
                while (target && TRACKING_TAGS.indexOf(tagName) === -1) {
                    target = target.parentElement;
                    tagName = target.tagName.toLowerCase();
                }
            }
            const page = window.location.href;
            const label = target.getAttribute('aria-label');
            let txt = target.textContent?.trim();
            if (txt) {
                txt = this.getOriginalText(txt);
            }
            let actionText =
                target.getAttribute('aria-describedby') ||
                txt || // Visible text content
                target.name || // Name attribute
                target.placeholder || // Placeholder attribute
                target.id ||
                target.getAttribute('data-testid');
            let action = this.formatAction(actionText);
            if (action) action += `_${tagName}`;

            if (action && (TRACKING_TAGS.indexOf(tagName) > -1 || label === 'tracker')) {
                event.stopPropagation();
                const eventData = {
                    page,
                    action,
                    meta: {
                        tagName,
                        id: target.id || null,
                        type: target.type,
                        classList: Array.from(target.classList || []),
                        name: target.name || null, // Element name (if available)
                        placeholder: target.placeholder || null, // Placeholder (if available)
                        attributes: this.getAttributes(target), // All attributes as key-value pairs
                        value: target.type === 'checkbox' ? target.checked : target.value
                    },
                };

                // Send data to the 
                await this.logEvent(eventData);
            }
        } catch (error) {
        }
    }

    async logEvent(eventData) {
        try {
            await payeeLogs(eventData)
        } catch (error) {
        }
    }

    getAttributes(element) {
        const attributes = {};
        for (const attr of element.attributes) {
            attributes[attr.name] = attr.value;
        }
        return attributes;
    }


    formatAction(actionText) {
        // Split by non-alphanumeric characters and replace spaces with underscores
        if (!actionText) return null;
        actionText = actionText.split('.')[0];
        return actionText
            .toLowerCase() // Convert to lowercase
            .split(/[ .,-]+/) // Split by spaces and special characters
            .filter(Boolean) // Remove empty values
            .join("_"); // Join with underscores
    }

    getOriginalText(translatedText) {
        const languages = Object.keys(i18next.store.data); // Get all available languages in your setup
        for (const lang of languages) {
            const translations = i18next.store.data[lang]?.translations || {};
            for (const [key, value] of Object.entries(translations)) {
                if (value?.toLowerCase() === translatedText?.toLowerCase()) {
                    if (i18next.store.data['EN']?.translations?.[key]) {
                        return i18next.store.data['EN']?.translations?.[key]; // Return the translation key if found
                    } else {
                        return translatedText;
                    }
                }
            }
        }

        return translatedText; // Fallback to the translated text if no key is found
    }
}

export default EventLogger;
